export const TRANSCRIPT_STATUS={
    PROCESSED:"PROCESSED",
    PROCESSING:"PROCESSING",
    NOT_ADDED:"NOT_ADDED"
}